import DOMPurify from 'dompurify';
import parse from 'html-react-parser';
import { useState} from 'react';
import classNames from 'classnames';

export default function Actu({ actu }) {

    const [isActive, setIsActive] = useState(false);

    const handleClick = () => {
        setIsActive(!isActive);
    }

    const ActuWindow = () => {

        return (
            <div className={classNames('popup-bg', { hidden: !isActive })}>
                <div className={classNames("popup-window w-4/5 p-5",(actu.color? "" : "bg-light-green"))} style={actu.color ? {backgroundColor: actu.color} : {}}>
                    <div>
                        <div className="image-label">
                            <img className="m-auto size-16"
                                src={actu.icon}
                                alt="icon"
                            />
                        </div>
                        <div className="ml-24 font-medium">{parse(DOMPurify.sanitize(actu.date))}</div>
                    </div>
                    <div>
                        <h1 className="text-black mt-5 mb-2">{parse(DOMPurify.sanitize(actu.title))}</h1>
                        {parse(DOMPurify.sanitize(actu.content))}
                    </div>
                    <img className="absolute top-1 right-1 size-9 cursor-pointer" alt="delete" src="/cross-delete.svg" onClick={handleClick}></img>
                </div>
            </div>
        )

    }

    const ActuPreview = () => {
        
        return (
            <div className={classNames("relative rounded-2xl shadow-md py-5 mt-5 cursor-pointer pl-28 pr-5",(actu.color? "" : "bg-light-green"))} style={actu.color ? {backgroundColor: actu.color} : {}} onClick={handleClick}>
                <div className="image-label">
                    <img className="m-auto size-16"
                        src={actu.icon}
                        alt="icon"
                    />
                </div>
                <div>
                    <h2 className="font-medium text-black">{parse(DOMPurify.sanitize(actu.title))}</h2>
                    <p className="font-medium text-sm">{parse(DOMPurify.sanitize(actu.date))}</p>
                </div>
                
            </div>
        )
    }

    return (
        <>
            <ActuPreview />
            <ActuWindow />
        </>
    );
}